import { AppThunk } from '../../../store/rootReducer';
import { sortWaves } from '../utils/wave.util';
import * as waveActions from '../actions/wave.actions';
import {
  selectedWavesSelector,
  waveForIdSelector,
  waveListSelector,
} from '../selectors/wave.selectors';
import { WaveId } from '../types/wave.type';

export const selectWavesInRange = (id: WaveId): AppThunk => async (
  dispatch,
  getState,
) => {
  const state = getState();
  const currentWave = waveForIdSelector(id)(state);
  const selectedWaves = selectedWavesSelector(state);
  const waveList = waveListSelector(state);

  if (selectedWaves.length === 0) {
    dispatch(waveActions.toggle({ waveIds: [id] }));
  } else {
    const lastSelectedWave = selectedWaves[selectedWaves.length - 1];
    const allowedType = selectedWaves[0].type;

    if (currentWave?.type !== allowedType) {
      return;
    }

    const [startWave, endWave] = [currentWave, lastSelectedWave].sort(
      sortWaves,
    );
    const startIndex = waveList.indexOf(startWave);
    const endIndex = waveList.indexOf(endWave, startIndex);

    if (startIndex > -1 && endIndex > -1) {
      dispatch(
        waveActions.select({
          waveIds: waveList
            .slice(startIndex, endIndex + 1)
            .filter(({ type }) => type === allowedType)
            .map(({ id }) => id),
        }),
      );
    }
  }
};
